import styled from "styled-components";


interface ContainerProps {
    isOpen?: boolean;
}

export const Container = styled.aside<ContainerProps>`
    min-height: calc(100vh - 72px);
    background-color: #fff;
    width: ${props => props.isOpen ? '250px' : '0px'};
    min-width: ${props => props.isOpen ? '250px' : '0px'};
    transition: .5s all ease-in-out;
    overflow: hidden;
    opacity: ${props => props.isOpen ? '1' : '0'};
    flex: 2;
    max-width: ${props => props.isOpen ? '250px' : '0px'};   
`;

export const Menu = styled.nav`
    display: flex;
    flex-direction: column;
    flex: 1;
    padding-top: 20px;

    ul {
        display: flex;
        flex-direction: column;
        padding: 0;
        margin: 0;
        list-style: none;
        flex: 1;

        li {
            display: flex;
            flex-direction: column;
            height: auto;
            border-bottom: 1px solid ${props => props.theme.colors.background};
            position: relative;
            box-sizing: content-box;

            &:last-child {
                border-bottom: none;
            }

            &.active, &.open {
                background-color: ${props => props.theme.colors.background};
                border: none;
                height: 66px;
                margin-bottom: -8px;
                margin-top: -8px;
                font-weight: bold;
                /* min-height: 66px; */

                
            
                &:last-child {
                    margin-top: -9px;
                    height: 66px;
                }

                &:first-child {
                    margin-bottom: -7px;
                    height: 66px;
                }


                &:before {
                    content: "";
                    display: block;
                    width: 100%;
                    height: 8px;
                    background-color: #fff;
                    position: absolute;
                    top: 0;
                    left: 0;
                    border-radius: 0 0 8px 0;
                }

                &:after {
                    content: "";
                    display: block;
                    width: 100%;
                    height: 8px;
                    background-color: #fff;
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    border-radius: 0 8px 0 0;
                }

                a {
                    color: ${props => props.theme.colors.primary};
                    height: 66px;
                }
            }

            &.open {
                height: auto;
                padding-top: 8px;
                padding-bottom: 8px;
                ol {
                    li {
                        margin: 0;

                        a {
                            color: ${props => props.theme.colors.primaryText};
                            font-weight: normal;
                            height: 30px;

                            &.active {
                                color: ${props => props.theme.colors.primary};
                                font-weight: bold;
                            }
                        }

                        &.active {
                            margin: 0;
                        }

                        &:last-child {
                            margin: 0;
                            height: 30px;
                        }

                        &:first-child {
                            margin: 0;
                            height: 30px;
                        }


                        &:before {
                            display: none;
                        }

                        &:after {
                            display: none;
                        }
                    }
                }
            }

            a {
                display: flex;
                flex: 1;
                align-items: center;
                padding: 0 15px;
                min-height: 50px;
                text-decoration: none;
            }

            
        }
    }
`;
export const SubMenu = styled.li`
    ol {
        display: flex;;
        margin: 0;
        flex-direction: column;
        overflow: hidden;
        height: 0;
        transition: all ease-in-out .3s;

        
        
        li {
            display: flex;
            flex: 1;
            padding: 0 15px;
            min-height: 30px;
            padding-left: 20px;
            border: none;

            a {
                max-height: 30px;
            }

            &.active {
                a {
                    max-height: 30px;
                }
            }
        }
    
    }

    &:hover, &.open {
        ol {
            height: auto;
        }
    }
`;